module.exports = __webpack_public_path__ + "static/list-title-bg4@2x-1c1e3edc901233bbd04207ecfe942da6.png";